import { render, staticRenderFns } from "./SuperAdminForgotPassword.vue?vue&type=template&id=5c94b160&scoped=true&"
import script from "./SuperAdminForgotPassword.vue?vue&type=script&lang=js&"
export * from "./SuperAdminForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c94b160",
  null
  
)

export default component.exports